<template>
  <div class="add-daodian-mobile">
    <div class="header">
      <el-button plain @click="router.back()">返回</el-button>
      <h2>新增到店记录</h2>
    </div>
    <el-form
      :model="form"
      ref="formRef"
      label-width="80px"
      :rules="formRules"
      class="form-container"
    >
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入客户姓名" clearable />
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input
          v-model="form.phone"
          placeholder="请输入客户电话"
          clearable
          maxlength="11"
        />
      </el-form-item>
      <el-form-item label="年龄" prop="age">
        <el-input
          v-model.number="form.age"
          placeholder="请输入客户年龄"
          type="number"
          min="1"
          max="150"
        />
      </el-form-item>
      <el-form-item label="类型" prop="leixing">
        <el-select
          v-model="form.leixing"
          placeholder="请选择到店类型"
          clearable
        >
          <el-option
            v-for="item in leixingList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="意向度" prop="yixiangdu">
        <el-select
          v-model="form.yixiangdu"
          placeholder="请选择意向度"
          clearable
        >
          <el-option label="高意向" value="A" />
          <el-option label="中意向" value="B" />
          <el-option label="低意向" value="C" />
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="dizhi">
        <el-input
          v-model="form.dizhi"
          placeholder="请输入客户地址"
          clearable
        />
      </el-form-item>
      <el-form-item label="情况" prop="qinkuang_miaoshu">
        <el-input
          type="textarea"
          v-model="form.qinkuang_miaoshu"
          placeholder="请输入情况描述（如到店目的、需求等）"
          rows="4"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import request from "@/util/request";
import { ElMessage } from "element-plus";

const router = useRouter();
const formRef = ref(null);
const leixingList = ref([]);

// 表单数据
const form = reactive({
  name: "",
  phone: "",
  age: null,
  leixing: "",
  yixiangdu: "",
  dizhi: "",
  qinkuang_miaoshu: ""
});

// 表单验证规则
const formRules = {
  name: [
    { required: true, message: "请输入客户姓名", trigger: "blur" },
    { min: 2, max: 20, message: "姓名长度在2-20个字符之间", trigger: "blur" }
  ],
  phone: [
    { required: true, message: "请输入客户电话", trigger: "blur" },
    { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" }
  ],
  age: [
    { required: true, message: "请输入客户年龄", trigger: "blur" },
    { type: "number", min: 1, max: 100, message: "年龄需在1-100之间", trigger: "blur" }
  ],
  leixing: [
    { required: true, message: "请选择到店类型", trigger: "change" }
  ],
  yixiangdu: [
    { required: true, message: "请选择意向度", trigger: "change" }
  ],
  dizhi: [
    { required: true, message: "请输入客户地址", trigger: "blur" },
    { min: 0, message: "地址至少0个字符", trigger: "blur" }
  ],
  qinkuang_miaoshu: [
    { required: true, message: "请输入情况描述", trigger: "blur" },
    { min: 3, message: "描述至少3个字符", trigger: "blur" }
  ]
};

// 获取到店类型列表
const getLeixingList = async () => {
  try {
    const res = await request.get("api/leixing/");
    if (res.data && res.data.code === 200) {
      leixingList.value = res.data.data || [];
    } else {
      ElMessage.error(res.data?.message || "获取到店类型失败");
    }
  } catch (err) {
    console.error("获取到店类型失败：", err);
    ElMessage.error("网络异常，获取到店类型失败");
  }
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;

  try {
    // 表单验证
    await formRef.value.validate();
    // 调用封装的post方法，发送请求到后端“新增到店记录”接口
    const res = await request.post("/api/daodian/create/", form);

    if (res.data.code === 201) {
      ElMessage.success("新增到店记录成功");
      router.back();
    } else {
      ElMessage.error(res.data?.message || "新增到店记录失败");
    }
  } catch (err) {
    if (err.name !== "ValidationError") {
      console.error("新增到店记录失败：", err);
      ElMessage.error("网络异常，新增失败");
    }
  }
};

// 页面初始化时获取到店类型
getLeixingList();
</script>

<style scoped>
.add-daodian-mobile {
  padding: 15px;
  background-color: #fff;
  min-height: calc(100vh - 30px);
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  flex: 1;
  text-align: center;
  margin: 0;
  font-size: 18px;
}

.form-container {
  max-width: 500px;
  margin: 0 auto;
}

.el-form-item {
  margin-bottom: 15px;
}

.el-input,
.el-select,
.el-textarea {
  width: 100%;
}
</style>